import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { hotelInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-bold text-gold-500 mb-4 font-serif">
              {hotelInfo?.name || 'Hotel Suvidha Deluxe'}
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              Experience luxury and comfort in the holy city of Haridwar. Your perfect stay awaits at our premium hotel near Har Ki Pauri.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/hotels4u.in?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-gold-600 transition-colors"
              >
                <Instagram size={16} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-gold-500 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-gold-500 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/rooms" className="text-gray-300 hover:text-gold-500 transition-colors text-sm">
                  Rooms & Tariff
                </Link>
              </li>
              <li>
                <Link to="/facilities" className="text-gray-300 hover:text-gold-500 transition-colors text-sm">
                  Facilities
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-300 hover:text-gold-500 transition-colors text-sm">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-gold-500 transition-colors text-sm">
                  About Haridwar
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-gold-500 transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-gold-500 mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-gold-500 mt-0.5 flex-shrink-0" />
                <span className="text-gray-300 text-sm">{hotelInfo?.address || 'Sarvarnath Nagar,Near Har Ki Pauri, Haridwar'}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-gold-500 flex-shrink-0" />
                <a href={`tel:${hotelInfo?.phone || '+911234567890'}`} className="text-gray-300 hover:text-gold-500 transition-colors text-sm">
                  {hotelInfo?.phone || '+91-8941000583'}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-gold-500 flex-shrink-0" />
                <a href={`mailto:${hotelInfo?.email || 'info@example.com'}`} className="text-gray-300 hover:text-gold-500 transition-colors text-sm">
                  {hotelInfo?.email || 'info@example.com'}
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-lg font-semibold text-gold-500 mb-4">Special Offers</h4>
            <p className="text-gray-300 text-sm mb-4">
              Subscribe to get special offers and updates about our hotel.
            </p>
            <div className="flex flex-col gap-2">
              <input
                type="email"
                placeholder="Your email"
                className="px-4 py-2 rounded-md bg-white/10 border border-white/20 text-white placeholder-gray-400 focus:outline-none focus:border-gold-500 text-sm"
              />
              <button className="px-4 py-2 bg-gold-600 hover:bg-gold-700 text-white rounded-md transition-colors text-sm font-medium">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} {hotelInfo?.name || 'Hotel Suvidha Deluxe'}. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="https://www.instagram.com/promopartnersads?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" className="text-gray-400 hover:text-gold-500 transition-colors">
              Powered by Promopartners
            </Link>
            <Link to="https://www.available.com" className="text-gray-400 hover:text-gold-500 transition-colors">
              Developed by available.com
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
